import { queryOptions } from "@tanstack/react-query";
import { QUERY_KEYS, STALE_TIME_SHORT } from "@/common/api/constants";
import { fetchLoanInfo } from "@/entities/loan/api/requests";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";

interface Props {
  token: string;
  setErrorMessage: SetErrorMessageType;
  refetchOnWindowFocus?: boolean;
  leadId?: number;
}

export const getLoanInfoQueryOption = ({
  leadId,
  token,
  setErrorMessage,
  refetchOnWindowFocus = true,
}: Props) =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_LOAN_INFO, leadId, token, setErrorMessage],
    queryFn: () => fetchLoanInfo({ token, leadId, setErrorMessage }),
    enabled: !!token && !!leadId,
    staleTime: STALE_TIME_SHORT,
    refetchOnWindowFocus,
  });
